import module from 'nominas/nomina/module.js'
import template from './template.html'

const encabezados = ['Folio', 'Colaborador', 'Concepto', 'Importe', 'Banco', 'Cuenta']

export class NominasNominaDispersionPagosExportarConfirmarComponent {
  data
  omitidos
  onClose
  incluirEncabezados = true
  copiable = false
  encabezados = [encabezados.join('\t')]
  opciones = []

  constructor ($document, $catalogos) {
    this.$document = $document
    this.$catalogos = $catalogos
    this.copiable = $document[0].queryCommandSupported('copy')
  }

  $onInit () {
    this.promise = this.$catalogos.get('monedas')
      .then((data) => {
        this.monedas = data.map((item) => ({id: Number(item.ID_Moneda), descripcion: item.Moneda}))
        this.opciones = this.data.reduce((carry, item) => carry.includes(item.id_moneda) ? carry : [...carry, item.id_moneda], [])

        this.data = this.data.map((item) => ({
            id_moneda: item.id_moneda,
            nombre: item.colaborador.split(', ').reverse().join(' '),
            concepto: `NOMINA ${item.id_nomina}`,
            importe: +(item.importe / (item.tipo_cambio || 1)).toFixed(2),
            banco: item.banco,
            cuenta: item.banco_cuenta,
            folio: item.cheque_numero,
          }))
          .sort((a, b) => a.nombre < b.nombre ? -1 : (a.nombre > b.nombre ? 1 : 0))
          .reduce((carry, item) => {
            let data = [
              item.folio,
              item.nombre,
              item.concepto,
              item.importe,
              item.banco,
              item.cuenta,
            ]

            if (!carry[item.id_moneda]) carry[item.id_moneda] = []

            carry[item.id_moneda].push(data.join('\t'))

            return carry
          }, {})

        this.idMoneda = this.opciones[0]

        this.generar()
      })
  }

  cerrar () {
    this.onClose()
  }

  copiar () {
    let elemento = this.$document[0].getElementById('nomina.pagos.otros.exportar.confirmar.texto')
    elemento.focus()
    elemento.select()
    document.execCommand('copy')
  }

  generar () {
    this.texto = []
      .concat(this.incluirEncabezados ? this.encabezados : [])
      .concat(this.data[this.idMoneda])
      .join('\n')
  }
}

module.component('nominasNominaDispersionPagosExportarConfirmar', {
  controller: NominasNominaDispersionPagosExportarConfirmarComponent,
  template,
  bindings: {
    data: '<',
    omitidos: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/exportar/confirmar/component.js